function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_134",
  "data-name": "Group 134"
}, React.createElement("path", {
  id: "Path_141",
  "data-name": "Path 141",
  d: "M12.188,4v.96a1.875,1.875,0,0,1-3.75,0V4H6.563v.96a1.875,1.875,0,0,1-3.75,0V4H0V17.125H15V4Zm-7.5,11.25H2.813V13.375H4.688Zm0-3.75H2.813V9.625H4.688Zm3.75,3.75H6.563V13.375H8.438Zm0-3.746H6.563V9.629H8.438Zm1.875,3.746V13.375h1.875Zm1.875-3.75H10.313V9.625h1.875Z",
  transform: "translate(0 -2.125)",
  fill: "#09b0ee"
}), React.createElement("path", {
  id: "Path_142",
  "data-name": "Path 142",
  d: "M8,2.813V.938a.938.938,0,0,1,1.875,0V2.813A.938.938,0,0,1,8,2.813Z",
  transform: "translate(-4.25)",
  fill: "#09b0ee"
}), React.createElement("path", {
  id: "Path_143",
  "data-name": "Path 143",
  d: "M20,2.813V.938a.938.938,0,0,1,1.875,0V2.813a.938.938,0,0,1-1.875,0Z",
  transform: "translate(-10.625)",
  fill: "#09b0ee"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "iconfinder_calendar_alt_fill_118721",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15"
  }, props), _ref);
};

export default __webpack_public_path__ + "storage/admin_static/media/calendar.38bf5cc7.svg";
export { SvgComponent as ReactComponent };